import { render, staticRenderFns } from "./UrunFiltrele.vue?vue&type=template&id=4ac66cf4&scoped=true"
import script from "./UrunFiltrele.vue?vue&type=script&lang=js"
export * from "./UrunFiltrele.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac66cf4",
  null
  
)

export default component.exports